import { useTranslation } from 'react-i18next';

interface AuthPromptProps {
  onAuthenticate: () => void;
}

export const AuthPrompt = ({ onAuthenticate }: AuthPromptProps) => {
  const { t } = useTranslation();
  return (
    <div className="h-full flex flex-col items-center justify-center bg-gradient-to-b from-white to-gray-50 p-2">
      <div className="w-full max-w-md p-8 rounded-2xl bg-white transform transition-all hover:scale-[1.02] duration-300 max-h-full">
        <div className="text-center space-y-4">
          {/* Lock Icon with animation */}
          <div className="inline-block p-3 bg-black/5 rounded-full mb-2">
            <svg
              className="w-8 h-8 text-gray-700 animate-bounce"
              fill="none"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              viewBox="0 0 24 24"
            >
              <path d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8V7a4 4 0 00-8 0v4" />
            </svg>
          </div>

          <p className="text-gray-600 text-sm leading-relaxed max-w-sm mx-auto">
            {t('authPrompt.message')}
          </p>

          <button
            className="w-full mt-3 bg-black text-white py-3 px-6 rounded-lg hover:bg-zinc-800
                       transform transition-all duration-200 hover:scale-[1.02] active:scale-[0.98]
                       flex items-center justify-center gap-2 font-medium shadow-sm"
            onClick={onAuthenticate}
          >
            <svg
              className="w-5 h-5"
              fill="currentColor"
              viewBox="0 0 24 24"
            >
              <path d="M12 0C5.383 0 0 5.383 0 12s5.383 12 12 12c6.616 0 12-5.383 12-12S18.616 0 12 0zm0 2c5.535 0 10 4.465 10 10s-4.465 10-10 10S2 17.535 2 12 6.465 2 12 2zm0 4a6 6 0 100 12 6 6 0 000-12z" />
            </svg>
            {t('authPrompt.connectAccount')}
          </button>
        </div>
      </div>
    </div>
  );
};
